'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import closeIcon from '@public/images/close_white.svg';
import Image from 'next/image';
import { Button } from '@src/components/Button/Button';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context';
import type { TopNavV6SubNavItem } from '@src/components/TopNavV6/TopNavV6Props';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
interface TopNavV6MobileMiniMenuProps {
  subNavItem: TopNavV6SubNavItem;
}
export const TopNavV6MobileMiniMenu = t0 => {
  const $ = _c(35);
  const {
    subNavItem
  } = t0;
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    setSelectedThirdLevelMenu,
    setIsMobileMenuOpen
  } = useTopNavV6();
  let t1;
  if ($[0] !== setSelectedThirdLevelMenu) {
    t1 = () => {
      setSelectedThirdLevelMenu(null);
    };
    $[0] = setSelectedThirdLevelMenu;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleBack = t1;
  let t2;
  if ($[2] !== setIsMobileMenuOpen || $[3] !== setSelectedThirdLevelMenu) {
    t2 = () => {
      setSelectedThirdLevelMenu(null);
      setIsMobileMenuOpen(false);
    };
    $[2] = setIsMobileMenuOpen;
    $[3] = setSelectedThirdLevelMenu;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClose = t2;
  let t3;
  if ($[5] !== setIsMobileMenuOpen || $[6] !== setSelectedThirdLevelMenu || $[7] !== trackSelectNavCta) {
    t3 = href => {
      if (href) {
        trackSelectNavCta({
          "cta url": href
        });
        setIsMobileMenuOpen(false);
        setSelectedThirdLevelMenu(null);
      }
    };
    $[5] = setIsMobileMenuOpen;
    $[6] = setSelectedThirdLevelMenu;
    $[7] = trackSelectNavCta;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleItemClick = t3;
  const miniMenu = subNavItem.miniMenu;
  const ctaButton = subNavItem.mobileCtaButton;
  if (!miniMenu) {
    return null;
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronLeftIcon className="size-6 text-bodi-accent-bright-500" />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== handleBack) {
    t5 = <button className="flex size-6 appearance-none items-center justify-center" onClick={handleBack} data-testid="backMiniMenu">{t4}</button>;
    $[10] = handleBack;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== subNavItem.title) {
    t6 = <div className="flex flex-1 items-center justify-center"><p className="text-body-md leading-[18px] font-semibold text-bodi-gray-butters uppercase">{subNavItem.title}</p></div>;
    $[12] = subNavItem.title;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image src={closeIcon} width={20} height={20} alt="Close menu" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== handleClose) {
    t8 = <button className="flex size-6 appearance-none items-center justify-center" onClick={handleClose} data-testid="closeMiniMenu">{t7}</button>;
    $[15] = handleClose;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t8) {
    t9 = <div className="flex h-12 items-center justify-between border-b border-bodi-gray-dark bg-linear-to-r from-white/8 to-white/8 px-4">{t5}{t6}{t8}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== handleItemClick || $[22] !== miniMenu.items) {
    let t11;
    if ($[24] !== handleItemClick) {
      t11 = (item_0, itemIndex) => {
        const content = <div className="flex items-center gap-1"><p className="text-body-sm leading-5 text-bodi-gray-butters">{item_0.title}</p>{item_0.badge && <div className="flex items-center gap-1 text-body-sm leading-5"><span className="font-sans font-normal text-bodi-gray-butters">-</span><span className="text-center font-sans font-medium text-bodi-accent-bright-500">{item_0.badge}</span></div>}</div>;
        if (item_0.href) {
          return <LocalizedLink key={`item-${itemIndex}`} href={item_0.href} className="flex w-full items-center text-left" onClick={() => {
            handleItemClick(item_0.href);
            item_0.onClick?.();
          }}>{content}</LocalizedLink>;
        }
        return <button key={`item-${itemIndex}`} className="flex w-full items-center text-left" onClick={() => {
          handleItemClick(item_0.href);
          item_0.onClick?.();
        }}>{content}</button>;
      };
      $[24] = handleItemClick;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    t10 = miniMenu.items.filter(_temp).map(t11);
    $[21] = handleItemClick;
    $[22] = miniMenu.items;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[26] !== t10) {
    t11 = <div className="flex flex-1 flex-col gap-3 overflow-y-auto px-4 pt-8 pb-8">{t10}</div>;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== ctaButton || $[29] !== handleItemClick) {
    t12 = ctaButton?.title && ctaButton.title !== "" && <div className="border-t border-bodi-gray-dark bg-bodi-black-text px-4 py-5">{ctaButton.href ? <LocalizedLink href={ctaButton.href} onClick={() => {
        handleItemClick(ctaButton.href);
        ctaButton.onClick?.();
      }}><Button className="w-full rounded-full" size="medium" variant="primary">{ctaButton.title}</Button></LocalizedLink> : <Button className="w-full rounded-full" size="medium" variant="primary" onClick={() => {
        ctaButton.onClick?.();
      }}>{ctaButton.title}</Button>}</div>;
    $[28] = ctaButton;
    $[29] = handleItemClick;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12 || $[33] !== t9) {
    t13 = <div className="flex h-full flex-col">{t9}{t11}{t12}</div>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t9;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};
function _temp(item) {
  return item.hiddenOn !== "mobile";
}